import React, { useState } from 'react';
import AnimateWithLottie from '@cp/components/AnimationWithLottie';
import breakTime from '@cp/assets/json/break.json';
import Button from '@primitives/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setIsAgentOnline } from '@cp/reducers/commonSlice';
import sendAgentAvailabilityStatusToSlash from '@cp/utils/sendAgentAvailabilityStatusToSlash';
import setAgentAvailability from '@cp/src/components/sidebar/actions/setAgentAvailability';
import { toast } from '@primitives/Toast';
import { RootState } from '@cp/src/store';
import dayjs from 'dayjs';
import { LocalStorage } from '@cp/utils/StorageUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import { DateTimeFormat } from '@cp/components/DateTimePicker/constants';

function BreakTime() {
  const dispatch = useDispatch();
  const breakTimeStarted = useSelector((store: RootState) => store.common.breakTimeStarted);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleSetOnline = () => {
    setIsSubmitting(true);
    setAgentAvailability(true, '')
      .then(res => {
        const lastRouteBeforeOffline = LocalStorage.getItem('lastRouteBeforeOffline');
        if (lastRouteBeforeOffline) {
          navigate(lastRouteBeforeOffline);
          localStorage.removeItem('lastRouteBeforeOffline');
        }
        dispatch(setIsAgentOnline(true));
        sendAgentAvailabilityStatusToSlash(true);
      })
      .catch(err => {
        toast.error('Unable to set online please try again');
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="flex justify-center items-center h-[100vh] flex-col">
      <div>
        <AnimateWithLottie
          animationData={breakTime}
          width={'225px'}
          height={'225px'}
          style={{
            marginLeft: '0rem',
            transform: 'translateX(0%)',
            position: 'static',
            left: '0'
          }}
        />
      </div>
      <div className="mt-6"> Taking a break</div>
      <div className="mt-4">
        {' '}
        <span className="text-[var(--blue-cyan)]">Started at </span>{' '}
        {dayjs(breakTimeStarted).format(DateTimeFormat.TIME_ONLY)}
      </div>
      <Button className="mt-12" onClick={handleSetOnline} disabled={isSubmitting}>
        {' '}
        Mark yourself online
      </Button>
    </div>
  );
}

export default BreakTime;
